import { alpha } from '@mui/system';
import { Fragment } from 'react';

import ChartIcon from '@/assets/svg/ui-elements/chart-green.svg';
import MailIcon from '@/assets/svg/ui-elements/mail.svg';
import { Separator, Typography } from '@/design-system';
import { colors } from '@/design-system/colors';
import { GAMMA_PRIME_EMAIL } from '@/shared/constants/social-links';

import { footerMenuLinks, footerSocialLinks } from './data';
import {
  FooterContacts,
  FooterMenu,
  FooterMenuItem,
  FooterMenuLink,
  FooterNavigation,
  FooterSection,
  FooterSocialLink,
  FooterSocials,
  FooterStatus,
  StyledFooter,
} from './Footer.styled';

export const Footer = () => {
  return (
    <StyledFooter>
      <FooterNavigation aria-label="Footer navigation">
        <FooterMenu>
          {footerMenuLinks.map((links, idx) => (
            <Fragment key={idx}>
              <FooterMenuItem>
                <Separator orientation="vertical" />
              </FooterMenuItem>

              {links.map((link) => (
                <FooterMenuItem key={link.text}>
                  <FooterMenuLink href={link.href} target="_blank" rel="noopener noreferrer">
                    {link.text}
                  </FooterMenuLink>
                </FooterMenuItem>
              ))}
            </Fragment>
          ))}
        </FooterMenu>
      </FooterNavigation>

      <FooterSection>
        <FooterContacts>
          <MailIcon width={16} height={16} />
          <FooterMenuLink href={GAMMA_PRIME_EMAIL}>
            {GAMMA_PRIME_EMAIL.replace('mailto:', '')}
          </FooterMenuLink>
        </FooterContacts>

        <Separator orientation="vertical" />

        <Typography variant="body4" color={alpha(colors.text.primary, 0.4)}>
          Follow us:
        </Typography>

        <FooterSocials aria-label="Social media">
          {footerSocialLinks.map((socialLink) => (
            <li key={socialLink.href}>
              <FooterSocialLink href={socialLink.href} target="_blank" rel="noopener noreferrer">
                {socialLink.icon}
              </FooterSocialLink>
            </li>
          ))}
        </FooterSocials>

        <Separator orientation="vertical" />

        <FooterStatus>
          <Typography variant="body4" color={colors.text.brand}>
            All services working
          </Typography>

          <ChartIcon width={10} height={10} />
        </FooterStatus>
      </FooterSection>
    </StyledFooter>
  );
};

Footer.displayName = 'Footer';
